export default __webpack_public_path__ + "static/media/morrisby_test_mock_bg.28a2151d.png";